import { defaultIconProps, IconProps } from './IconProps';

export const IconInputs: import('react').FC<IconProps> = ({ size, color, strokeWidth = 1.5, ...rest }) => (
  <svg width={size} height={size} viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <path
      d="M5 14.1667C5 14.4594 5 14.6058 5.01306 14.7331C5.12146 15.7895 5.8855 16.6622 6.91838 16.9093C7.04279 16.939 7.18792 16.9584 7.47807 16.9971L12.9713 17.7295C14.535 17.938 15.3169 18.0423 15.9237 17.801C16.4565 17.5891 16.9002 17.2006 17.1806 16.7005C17.5 16.1309 17.5 15.3421 17.5 13.7646V6.23541C17.5 4.65787 17.5 3.8691 17.1806 3.2995C16.9002 2.7994 16.4565 2.41088 15.9237 2.19904C15.3169 1.95776 14.535 2.062 12.9713 2.2705L7.47807 3.00293C7.18788 3.04162 7.04279 3.06097 6.91838 3.09073C5.8855 3.33781 5.12145 4.21049 5.01306 5.26696C5 5.39421 5 5.54059 5 5.83334M10 6.66668L13.3333 10M13.3333 10L10 13.3333M13.3333 10H2.5"
      stroke={color}
      strokeWidth={strokeWidth}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

IconInputs.defaultProps = defaultIconProps;
